"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = require("@stylegator/app");

Object.keys(_app).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _app[key];
    }
  });
});